var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnergyContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 45,
    viewBox: "0 0 30 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4692 17.1308H16.6388L17.6703 2.12308C17.6869 1.78433 17.5918 1.4495 17.3995 1.17011C17.2073 0.890715 16.9285 0.682235 16.6062 0.576745C16.2839 0.471255 15.9358 0.474599 15.6156 0.586264C15.2953 0.697928 15.0206 0.911726 14.8338 1.19476L0.238627 24.8668C0.0895123 25.1031 0.00720677 25.3755 0.000452071 25.6549C-0.00630262 25.9343 0.0627466 26.2103 0.200264 26.4536C0.337782 26.6969 0.538633 26.8984 0.781482 27.0367C1.02433 27.175 1.30011 27.2449 1.57952 27.2391H12.6161L11.4815 42.4531C11.454 42.8029 11.5462 43.1517 11.743 43.4422C11.9398 43.7327 12.2295 43.9477 12.5646 44.0519H13.0287C13.2955 44.0574 13.5592 43.9938 13.7942 43.8673C14.0291 43.7408 14.2274 43.5556 14.3696 43.3299L28.81 19.4516C28.9459 19.2163 29.0174 18.9494 29.0173 18.6777C29.0173 18.4061 28.9457 18.1392 28.8098 17.904C28.6739 17.6687 28.4784 17.4734 28.2431 17.3377C28.0078 17.202 27.7408 17.1306 27.4692 17.1308ZM15.0401 36.2128L15.8137 25.7951C15.8278 25.5834 15.7983 25.371 15.7269 25.1713C15.6555 24.9715 15.5438 24.7885 15.3986 24.6337C15.2535 24.479 15.0782 24.3557 14.8834 24.2715C14.6886 24.1874 14.4786 24.1443 14.2665 24.1447H4.36446L14.1633 8.15711L13.4413 18.5749C13.4272 18.7865 13.4567 18.9989 13.5281 19.1987C13.5995 19.3984 13.7112 19.5814 13.8563 19.7362C14.0014 19.891 14.1768 20.0142 14.3716 20.0984C14.5663 20.1825 14.7763 20.2257 14.9885 20.2252H24.7358L15.0401 36.2128Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0.5,
    x2: 40.1927,
    y2: 27.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergyContract);
export default __webpack_public_path__ + "static/media/icon-energy-contract.0b04f0e835440f3b979480f403848a00.svg";
export { ForwardRef as ReactComponent };